import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { FileUploadService } from '../attachments/file-upload.service';

/**
 * Auf diesen Service kann subscribed werden um den Fortschritt von Dateiuploads
 * oder Dateidownloads (z.B. {@link FileUploadComponent} zu erhalten. Der Service
 * wird von {@link HttpProgressInterceptor} befüllt.
 */
@Injectable()
export class HttpActiveRequestService {

    change$: Subject<HttpProgressInfo> = new ReplaySubject(1);

    private httpProgressInfo = new HttpProgressInfo();

    onStarted(request: HttpRequest<any>) {
        if (this.httpProgressInfo.downloadsInProgress.size === 0) {
            this.httpProgressInfo.downloadsStarted = new Date();
        }
        const id = HttpActiveRequestService.getId(request);
        const info = new HttpInfo(id, 1, true);
        this.httpProgressInfo.downloadsInProgress.set(id, info);
        this.change$.next(this.httpProgressInfo);
    }

    onProgress(request: HttpRequest<any>, progress: number, download: boolean) {
        const id = HttpActiveRequestService.getId(request);
        const info: HttpInfo = this.httpProgressInfo.downloadsInProgress.get(id) || new HttpInfo(id, progress, download);
        info.progress(progress);
        info.download = download;
        this.change$.next(this.httpProgressInfo);
    }

    onFinished(request: HttpRequest<any>) {
        const id = HttpActiveRequestService.getId(request);
        this.httpProgressInfo.downloadsInProgress.delete(id);
        if (this.httpProgressInfo.downloadsInProgress.size === 0) {
            this.httpProgressInfo.downloadsStarted = null;
        }
        this.change$.next(this.httpProgressInfo);
    }

    private static getId(request: HttpRequest<any>): string {
        return request.headers.get(FileUploadService.UPLOAD_ID_HEADER) || JSON.stringify(request);
    }
}

export class HttpProgressInfo {
    // Gibt an, wann der erste Download begann. Wird zurückgesetzt, wenn nichts mehr in Progress ist.
    downloadsStarted: Date;

    // TODO "downloads" ist hier falsch, da hier auch Uploads mit rein zählen
    downloadsInProgress: Map<string, HttpInfo> = new Map<string, HttpInfo>();
}

export class HttpInfo {
    started: Date;

    constructor(public id: string, public loaded: number, public download: boolean) {
        this.started = new Date();
    }

    progress(loaded: number) {
        this.loaded = loaded;
    }
}
